import { UserOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal, Space, Typography } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import calls from '../api/calls';

export const NewInvestorButton = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [values, setValues] = useState<{ email: string }>({ email: '' });
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState<string>();

  const formChangeHandler = (changedValues) => setValues({ ...values, ...changedValues });

  const formHandler = async () => {
    setLoading(true);
    try {
      const { password } = await calls.investors.createInvestor(values.email);
      setPassword(password);
    } finally {
      setLoading(false);
    }
  };

  const modalCancelHandler = () => {
    setPassword(null);
    setVisible(false);
  };

  const buttonClickHandler = () => {
    setPassword(null);
    setVisible(true);
  };

  const renderModalButtons = () => [
    <Button key="cancel" onClick={modalCancelHandler} loading={loading}>
      {t('cancel')}
    </Button>,
  ];

  return (
    <>
      <Button type="ghost" style={{ width: '100%', marginBottom: 16 }} onClick={buttonClickHandler} loading={loading}>
        {t('newInvestor')}
      </Button>
      <Modal title={t('newInvestor')} visible={visible} closable={false} footer={renderModalButtons()}>
        {!password ? (
          <Form onFinish={formHandler} onValuesChange={formChangeHandler}>
            <Form.Item name="email" rules={[{ required: true, message: t('emailInvalid'), type: 'email' }]}>
              <Input
                value={values.email}
                type="email"
                placeholder={t('email')}
                prefix={<UserOutlined />}
                readOnly={loading}
              />
            </Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} className="pg-u-full-width">
              {t('submit')}
            </Button>
          </Form>
        ) : (
          <Space direction="vertical" size={12}>
            <Typography.Text strong>{t('createInvestorSuccess')}</Typography.Text>
            <div>
              {t('email')}
              {': '}
              <Typography.Text code copyable>
                {values.email}
              </Typography.Text>
            </div>
            <div>
              {t('temporaryPassword')}
              {': '}
              <Typography.Text code copyable>
                {password}
              </Typography.Text>
            </div>
          </Space>
        )}
      </Modal>
    </>
  );
};
